import { Pipe, PipeTransform } from '@angular/core';
import { Product } from '../../types/product.type';

export const monthYearDiffPrice = (product: Product, invert = false): number => {
  if (!product) return;
  const prices = product.prices;
  const monthlyPrice = prices.find(price => price.recurring.interval === 'month');
  const yearlyPrice = prices.find(price => price.recurring.interval === 'year');

  if (!monthlyPrice || !yearlyPrice) return;

  const monthlyAmount = monthlyPrice.unit_amount;
  const adjustedYearPrice = yearlyPrice.unit_amount / 12;

  const percentDiff = ((adjustedYearPrice - monthlyAmount) / monthlyAmount) * 100;

  // round to nearest 5
  const roundedDiff = Math.round(percentDiff);

  if (invert) return roundedDiff * -1;
  return roundedDiff;
};

@Pipe({
  name: 'monthYearDiff',
  standalone: true,
})
export class MonthYearDiffPipe implements PipeTransform {
  transform(product: Product, invert = false): string {
    const diff = monthYearDiffPrice(product, invert);
    if (!diff) return '';
    return `${diff}%`;
  }
}
